import { clientEnv } from "@/env/client";
import { ReactNode } from "react";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

const recaptchaEnabled =
  clientEnv.NEXT_PUBLIC_FEATURE_FLAG_RECAPTCHA_FOR_MEMBERS_SIGNUP === "enable";

export const ReCaptchaProvider = ({ children }: { children: ReactNode }) => {
  return recaptchaEnabled ? (
    <GoogleReCaptchaProvider
      reCaptchaKey={clientEnv.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
    >
      {children}
    </GoogleReCaptchaProvider>
  ) : (
    children
  );
};

type ExecuteResponse =
  | {
      type: "not_enabled";
      token: undefined;
    }
  | {
      type: "failed";
      token: undefined;
    }
  | {
      type: "success";
      token: string;
    };

export const useReCaptcha = (): { execute: () => Promise<ExecuteResponse> } => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const execute = async (): Promise<ExecuteResponse> => {
    if (!recaptchaEnabled) {
      return { type: "not_enabled", token: undefined };
    }

    const token = await executeRecaptcha?.();
    if (!token) {
      return { type: "failed", token: undefined };
    }
    return { type: "success", token };
  };

  return { execute };
};
